import * as React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";
import {Country} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";

interface IProps {
    offer: IOffer;
    country: Country;
}

export const OfferGeneratedDescriptionTextCommercials = (props: IProps) => {
    const {offer, country} = props;

    const futureEndDate = props.offer.construction_date_range?.upper && isFuture(parseISO(props.offer.construction_date_range.upper));
    const futureStartDate = props.offer.construction_date_range?.lower && isFuture(parseISO(props.offer.construction_date_range.lower));

    const upper = props.offer.construction_date_range?.upper && formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego lokalu użytkowego", "nowych lokali użytkowych", "nowych lokali użytkowych"]);
    //commercials
    const commercialsPlural = pluralize(["nowy lokal użytkowy", "nowe lokale użytkowe", "nowych lokali użytkowych"]);
    // others
    const arePlural = pluralize(["jest", "są", "jest"]);

    return (
        <>
            <p>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper && `z planowanym na ${upper} roku terminem oddania do użytkowania`
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper && `w ${upper} roku`}`}
                .
            </p>

            {offer.properties && (
                <p>
                    Cały projekt składa się z {offer.properties} {propertiesPlural(offer.properties)}.
                </p>
            )}

            <p>
                {!!offer.stats?.properties_count_for_sale ? (
                    <>
                        Aktualnie w inwestycji {offer.name} w sprzedaży {arePlural(offer.stats.properties_count_for_sale)}{" "}
                        {offer.stats.properties_count_for_sale} {commercialsPlural(offer.stats.properties_count_for_sale)}
                        {!!offer.stats.ranges_area_min &&
                            ` o powierzchni ${
                                offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                    ? `${offer.stats.ranges_area_min}`
                                    : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                            } metrów kwadratowych`}
                        {offer.stats.ranges_price_m2_min
                            ? `, w cenie od ${numberFormat(offer.stats.ranges_price_m2_min)} ${country === Country.POLAND ? "zł" : "eur"} za metr kwadratowy`
                            : ""}
                        .
                    </>
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych lokali użytkowych w sprzedaży.</>
                )}
            </p>
        </>
    );
};
import * as React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";
import {Country} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";

interface IProps {
    offer: IOffer;
    country: Country;
}

export const OfferGeneratedDescriptionTextCommercials = (props: IProps) => {
    const {offer, country} = props;

    const futureEndDate = props.offer.construction_date_range?.upper && isFuture(parseISO(props.offer.construction_date_range.upper));
    const futureStartDate = props.offer.construction_date_range?.lower && isFuture(parseISO(props.offer.construction_date_range.lower));

    const upper = props.offer.construction_date_range?.upper && formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego lokalu użytkowego", "nowych lokali użytkowych", "nowych lokali użytkowych"]);
    //commercials
    const commercialsPlural = pluralize(["nowy lokal użytkowy", "nowe lokale użytkowe", "nowych lokali użytkowych"]);
    // others
    const arePlural = pluralize(["jest", "są", "jest"]);

    return (
        <>
            <p>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper && `z planowanym na ${upper} roku terminem oddania do użytkowania`
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper && `w ${upper} roku`}`}
                .
            </p>

            {offer.properties && (
                <p>
                    Cały projekt składa się z {offer.properties} {propertiesPlural(offer.properties)}.
                </p>
            )}

            <p>
                {!!offer.stats?.properties_count_for_sale ? (
                    <>
                        Aktualnie w inwestycji {offer.name} w sprzedaży {arePlural(offer.stats.properties_count_for_sale)}{" "}
                        {offer.stats.properties_count_for_sale} {commercialsPlural(offer.stats.properties_count_for_sale)}
                        {!!offer.stats.ranges_area_min &&
                            ` o powierzchni ${
                                offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                    ? `${offer.stats.ranges_area_min}`
                                    : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                            } metrów kwadratowych`}
                        {offer.stats.ranges_price_m2_min
                            ? `, w cenie od ${numberFormat(offer.stats.ranges_price_m2_min)} ${country === Country.POLAND ? "zł" : "eur"} za metr kwadratowy`
                            : ""}
                        .
                    </>
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych lokali użytkowych w sprzedaży.</>
                )}
            </p>
        </>
    );
};
